import React from 'react';
import { Flex, Image, Link, Text } from 'pcln-design-system';
import styled from 'styled-components';
import { RichMediaBanner } from '@pcln/marketing';
import BannerIcon from './AnimatedIcon';
export const PoweredByPenny = () => React.createElement(Flex, {
  alignItems: 'flex-start'
}, React.createElement(Text.span, {
  fontSize: 0
}, "Powered by"), React.createElement(Image, {
  alt: 'Penny Logo',
  ml: 1,
  height: '14.5px',
  src: 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_penny_logo_v1.1.svg'
}));
const LinkWrapper = /*#__PURE__*/styled(Link).withConfig({
  displayName: "AppHandoffCard__LinkWrapper",
  componentId: "sc-1siuxca-0"
})(["display:block;:hover{text-decoration:none;}"]);
/** @public */
const AppHandoffBanner = ({
  heading,
  callToActionText,
  href,
  onClick,
  playAnimation = true
}) => {
  function handleClick() {
    onClick?.();
  }
  const headingText = heading || 'Get tailored recommendations for your upcoming trip, available exclusively in the app';
  return React.createElement(LinkWrapper, {
    href: href,
    textDecoration: 'none',
    target: '_blank',
    onClick: handleClick
  }, React.createElement(RichMediaBanner, {
    backgroundColor: 'background.lightest',
    heading: headingText,
    paragraph: React.createElement(PoweredByPenny, null),
    callToAction: callToActionText ? {
      buttonText: callToActionText
    } : null,
    buttonVariation: 'fill',
    imageLeft: React.createElement(BannerIcon, {
      playAnimation: playAnimation
    })
  }));
};
export default AppHandoffBanner;